var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61887 8.65201L12.85 1.33301M5.32395 8.81433L1.58331 1.33301M8.30995 8.30785L4.90698 1.33301M9.69531 1.33301L8.79398 3.49967M2.44998 13.4663C2.44998 16.3382 4.7781 18.6663 7.64998 18.6663C10.5219 18.6663 12.85 16.3382 12.85 13.4663C12.85 10.5945 10.5219 8.26634 7.64998 8.26634C4.7781 8.26634 2.44998 10.5945 2.44998 13.4663Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34991 12.5998L8.08325 11.2998V15.6331",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLevel);
export default __webpack_public_path__ + "static/media/userLevel.4950adf64bb31420e54361b1c5dc4b6a.svg";
export { ForwardRef as ReactComponent };